// extracted by mini-css-extract-plugin
export var menuDisplayButton = "header-main-module--menu-display-button--140yc";
export var headerMain = "header-main-module--header-main---Kef2";
export var navigationHolder = "header-main-module--navigation-holder--16ZZt";
export var active = "header-main-module--active--1NxK2";
export var logoHolder = "header-main-module--logo-holder--3ABlX";
export var headerInner = "header-main-module--header-inner--3UN8i";